export enum RecurrencePrestationTypeEnum {
  LOGIC = 'LOGIC',
  MANUAL = 'MANUAL',
}
